export default __webpack_public_path__ + "images/d2a024f7551316ad45bfdfcd2120b265.png";